import {
  ClickAwayListener,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Paper,
  Popper,
  Stack,
  Typography,
  useTheme,
} from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getUserTypeFromToken } from '../../_helpers/cookie'
import { useAppDispatch, useAppSelector } from '../../_helpers/hooks'
import { LanguageIcon } from '../../components/icons'
import {
  getLanguages,
  setCommonLanguage,
  translation,
  translationData,
} from '../../slices/translationSlice'

const LanguageSelector = () => {
  const theme = useTheme()
  const [open, setOpen] = useState(false)
  const anchorRef = useRef<HTMLDivElement>(null)
  const { languages } = useAppSelector(translationData)
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  useEffect(() => {
    if (!languages?.length) {
      dispatch(getLanguages())
    }
  }, [languages?.length, dispatch])

  const handleToggle = (event: React.MouseEvent) => {
    event.stopPropagation()
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event: Event | TouchEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return
    }
    setOpen(false)
  }

  const handleLanguageSelect = (languageCode: string, event?: React.MouseEvent) => {
    if (event) {
      event.stopPropagation()
    }
    const loggedInUserType = getUserTypeFromToken()
    dispatch(translation(languageCode ?? 'en'))
    if (loggedInUserType === 'super_admin') {
      dispatch(setCommonLanguage(languageCode ?? 'en'))
    }
    setOpen(false)
  }
  return (
    <>
      <Stack
        direction={'row'}
        spacing={2}
        ref={anchorRef}
        onClick={(e) => handleToggle(e)}
        sx={{ cursor: 'pointer' }}
      >
        <LanguageIcon height='20' width='20' fill={theme.palette.profileIcon.colorFifteen} />
        <Typography variant='subtitle1' color='description.light' fontWeight={'normal'}>
          {t('superAdminProfileDrawer.languageText')}
        </Typography>
      </Stack>

      <Popper open={open} anchorEl={anchorRef.current} placement='top-start' sx={{ zIndex: 1300 }}>
        <ClickAwayListener onClickAway={handleClose}>
          <Paper elevation={3} sx={{ minWidth: 150, mt: 1 }}>
            <List>
              {languages.map((language) => (
                <ListItem key={language.lang_code} disablePadding>
                  <ListItemButton onClick={(e) => handleLanguageSelect(language.lang_code, e)}>
                    <ListItemText
                      primary={language.language}
                      primaryTypographyProps={{ variant: 'body2' }}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  )
}

export default LanguageSelector
